import { render, staticRenderFns } from "./NewPool.vue?vue&type=template&id=072fe67a&"
import script from "./NewPool.vue?vue&type=script&lang=js&"
export * from "./NewPool.vue?vue&type=script&lang=js&"
import style0 from "./NewPool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports